// Module
var code = "<a subscription-entity=\"CONTACTS\" data-bind=\"text: name, attr: {\r\n                                    'command-type': type,\r\n                                    title: name,\r\n                                    href: 'http://{URL_COMMAND=' + id + '}'\r\n                                }\" target=\"_blank\" rel=\"noopener\"></a>";
// Exports
export default code;